import { useState } from 'react';
import { Button, DatePicker, Form, Input, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import UserService from '../../../../../services/UserService';
import RopaService from '../../../../../services/Ropa.service';
import { useAuthContext } from '../../../../../context/auth-context';
import useNotify from '../../../../../context/Notification/useNotify';
import { ROUTER } from '../../../../../constants/router';

const ModalReviewed = ({
    open,
    handelClose,
    getRoPaDetailHeader,
    status,
    setIsChangeStatus,
}) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const reviewBy = UserService.getUi();
    let { activityId } = useParams();
    const [loading, setLoading] = useState(false);
    const [startDate, setStartDate] = useState(moment());
    const [endDate, setEndDate] = useState();
    const notify = useNotify();
    let navigate = useNavigate();

    const { username } = useAuthContext();

    const onFinish = async (values) => {
        const payload = {
            activityId,
            status,
            lastReviewDate: values.lastReviewDate.toISOString(),
            nextReviewDue: values.nextReviewDue
                ? values.nextReviewDue.toISOString()
                : '',
            reason: '',
            comment: values.comment,
        };
        setLoading(true);
        try {
            const { data } = await RopaService.changeStatusRopa(payload);
            if (data.resultCode === 1) {
                getRoPaDetailHeader();
                setLoading(false);
                setIsChangeStatus(true);
                handelClose();
                notify({
                    title: t('common.Success'),
                    description: t('Successfully save data'),
                });
                navigate(`${ROUTER.DS_INVENTORY.ROPA}/${activityId}/view`);
            } else {
                setLoading(false);
                handelClose();
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to submitted'),
                });
            }
            form.resetFields();
        } catch (error) {
            console.log(error);
            setLoading(false);
            handelClose();
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
        }
    };

    const disabledDateStart = (current) => {
        return current && current > endDate;
    };

    const disabledDate = (current) => {
        return current && current < startDate;
    };

    return (
        <Modal
            width={450}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    reviewBy,
                    lastReviewDate: moment(),
                    nextReviewDue: '',
                }}
            >
                <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                    <div className="text-2xl font-semibold">
                        {t('dataFlow.ReviewComplete')}
                    </div>
                </div>
                <div className="mt-6 mb-24">
                    <Form.Item label={t('dataFlow.ReviewBy')} name="reviewBy">
                        {username}
                    </Form.Item>
                    <Form.Item
                        label={t('dataFlow.LastReviewDate')}
                        name="lastReviewDate"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'dataFlow.PleaseInputLastReviewDate'
                                ),
                            },
                        ]}
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t(
                                'dataFlow.PleaseSelectLastReviewDate'
                            )}
                            onChange={(value) => {
                                setStartDate(value);
                            }}
                            disabledDate={disabledDateStart}
                        />
                    </Form.Item>
                    <Form.Item
                        label={t('dataFlow.NextReviewDue')}
                        name="nextReviewDue"
                    >
                        <DatePicker
                            style={{ width: '100%' }}
                            size="large"
                            showTime
                            disabledDate={disabledDate}
                            onChange={(value) => {
                                setEndDate(value);
                            }}
                            format="DD/MM/YYYY HH:mm"
                            placeholder={t(
                                'dataFlow.PleaseSelectNextReviewDue'
                            )}
                        />
                    </Form.Item>
                    <Form.Item label={t('Additional comments')} name="comment">
                        <Input.TextArea maxLength={500} showCount rows={4} />
                    </Form.Item>
                </div>
                <div className="flex justify-center items-center space-x-4">
                    <Button
                        type="primary"
                        onClick={handelClose}
                        size="large"
                        ghost
                    >
                        {t('common.Cancel')}
                    </Button>

                    <Button
                        loading={loading}
                        size="large"
                        htmlType="submit"
                        type="primary"
                    >
                        {t('common.Submit')}
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
export default ModalReviewed;
